import React, { useEffect, useState } from 'react';

import LoadingIndicator from '@magoosh/layouts/components/loading_indicator';
import { secondsFormattedAsHoursAndMinutes, secondsFormattedAsMinutes } from 'utilities/time';

import * as api from '@test_prep/app/api';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  filters: any;
}

export default (props: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [summary, setSummary] = useState(null);

  const loadSummary = () => {
    setIsLoading(true);

    api.fetchAnswersSummary(props.filters).then((summary) => {
      setSummary(summary);
      setIsLoading(false);
    });
  };

  const paceColor = () => {
    if (summary.paceAverage < summary.otherPaceAverage) {
      return colors.brandPrimary;
    } else if (summary.paceAverage > summary.otherPaceAverage) {
      return colors.brandDanger;
    } else {
      return '#98A2B3';
    }
  };

  useEffect(() => {
    loadSummary();
  }, [props.filters]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <LoadingIndicator />
      </div>
    )
  }

  return (
    <div className="d-flex flex-column flex-sm-row gap-m">
      <div className="align-items-center align-items-sm-start d-flex flex-1 flex-column gap-s">
        <div className="text-bold" style={{ color: '#697586' }}>
          Your Performance
        </div>

        <div className="align-items-center d-flex gap-xs">
          <div className="h2 text-bold u-margin-A-n">
            {summary.correctAnswerPercentage}
          </div>

          <div style={{ color: '#697586' }}>
            ({summary.correctAnswerCount} of {summary.answerCount})
          </div>
        </div>
      </div>

      <div className={style.divider} />

      <div className="align-items-center align-items-sm-start d-flex flex-1 flex-column gap-s">
        <div className="text-bold" style={{ color: '#697586' }}>
          Your Average Pace
        </div>

        <div className="align-items-center d-flex gap-xs">
          <ClockIcon fill={paceColor()} />

          <div className="h2 text-bold u-margin-A-n" style={{ color: paceColor() }}>
            {secondsFormattedAsMinutes(summary.paceAverage, false)}
          </div>

          <div style={{ color: '#697586' }}>
            ({secondsFormattedAsHoursAndMinutes(summary.paceTotal)} total)
          </div>
        </div>
      </div>

      <div className={style.divider} />

      <div className="align-items-center align-items-sm-start d-flex flex-1 flex-column gap-s">
        <div className="text-bold" style={{ color: '#697586' }}>
          Others' Average Pace
        </div>

        <div className="align-items-center d-flex gap-xs">
          <ClockIcon fill="#98A2B3" />

          <div className="h2 text-bold u-margin-A-n">
            {secondsFormattedAsMinutes(summary.otherPaceAverage)}
          </div>

          <div style={{ color: '#697586' }}>
            ({secondsFormattedAsHoursAndMinutes(summary.otherPaceTotal)} total)
          </div>
        </div>
      </div>
    </div>
  );
};

const ClockIcon = ({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height={25} width={25} fill={fill}>
      <path d="M320 64c141.4 0 256 114.6 256 256S461.4 576 320 576 64 461.4 64 320 178.6 64 320 64m-24 120v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L344 307.2V184c0-13.3-10.7-24-24-24s-24 10.7-24 24"/>
    </svg>
  );
}
